/**
 * 付款（借款端：征信 hard-pull 付费）。
 *
 * 与 LOS PAYMENT_PAY（套餐付款）刻意不同名，避免跨端同名混计：
 * - LOS：PAYMENT_PAY value=plan
 * - 借款端：PAYMENT_CREDIT_PULL_PAY value=credit_pull
 */
export enum PaymentEvent {
    /**
     * 从列表 / Credit check 点进付费页。
     * value 与 metadata.type 相同：credit_pull
     * 属性 source=my_loans|creditcheck；request_id；loan_id
     */
    OPEN = 'PAYMENT_CREDIT_PULL_OPEN',
    /**
     * 征信付费结果（有结果才打）。
     * value 与 metadata.type 相同：credit_pull
     * 属性 result=success|fail；request_id；loan_id；amount
     */
    PAY = 'PAYMENT_CREDIT_PULL_PAY',
}
